import { absMonitor } from '#/store/hooks/useForms/Import/types/absMonitor'
import { animal } from '#/store/hooks/useForms/Import/types/animal'
import { animalsAProtocol } from '#/store/hooks/useForms/Import/types/animalsAProtocol'
import { animalsIntoProtocol } from '#/store/hooks/useForms/Import/types/animalsIntoProtocol'
import { bodyAssessment } from '#/store/hooks/useForms/Import/types/bodyAssessment'
import { bovisync } from '#/store/hooks/useForms/Import/types/bovisync'
import { bovisyncDiscards } from '#/store/hooks/useForms/Import/types/bovisyncDiscards'
import { calving } from '#/store/hooks/useForms/Import/types/calving'
import { ccom } from '#/store/hooks/useForms/Import/types/ccom'
import { cenv } from '#/store/hooks/useForms/Import/types/cenv'
import { ctech } from '#/store/hooks/useForms/Import/types/ctech'
import { dairyComp } from '#/store/hooks/useForms/Import/types/dairyComp'
import { dairyPlan } from '#/store/hooks/useForms/Import/types/dairyPlan'
import { dairyPlanDiscards } from '#/store/hooks/useForms/Import/types/dairyPlanDiscards'
import { delpro } from '#/store/hooks/useForms/Import/types/delpro'
import { delproDiscards } from '#/store/hooks/useForms/Import/types/delproDiscards'
import { discards } from '#/store/hooks/useForms/Import/types/discards'
import { dry } from '#/store/hooks/useForms/Import/types/dry'
import { farmAnimalUpdate } from '#/store/hooks/useForms/Import/types/farmAnimalUpdate'
import { health } from '#/store/hooks/useForms/Import/types/health'
import { ideagri } from '#/store/hooks/useForms/Import/types/ideagri'
import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'
import { leigado } from '#/store/hooks/useForms/Import/types/leigado'
import { lely } from '#/store/hooks/useForms/Import/types/lely'
import { mating } from '#/store/hooks/useForms/Import/types/mating'
import { milk } from '#/store/hooks/useForms/Import/types/milk'
import { prepartum } from '#/store/hooks/useForms/Import/types/prepartum'
import { reproduction } from '#/store/hooks/useForms/Import/types/reproduction'
import { reproductiveEventHistory } from '#/store/hooks/useForms/Import/types/reproductiveEventHistory'
import { review } from '#/store/hooks/useForms/Import/types/review'
import { systemBullSemen } from '#/store/hooks/useForms/Import/types/systemBullSemen'
import { uniformAgri } from '#/store/hooks/useForms/Import/types/uniformAgri'
import { uniformAgriDiscards } from '#/store/hooks/useForms/Import/types/uniformAgriDiscards'

const configs: ImportTypeConfig[] = [
  absMonitor,
  animal,
  animalsAProtocol,
  animalsIntoProtocol,
  bodyAssessment,
  bovisync,
  calving,
  ccom,
  cenv,
  ctech,
  dairyComp,
  dairyPlan,
  dairyPlanDiscards,
  delpro,
  delproDiscards,
  discards,
  dry,
  farmAnimalUpdate,
  health,
  ideagri,
  leigado,
  lely,
  mating,
  milk,
  prepartum,
  reproduction,
  reproductiveEventHistory,
  review,
  systemBullSemen,
  uniformAgri,
  uniformAgriDiscards,
  bovisyncDiscards,
]

export const importTypeConfigs: Record<string, ImportTypeConfig> = Object.fromEntries(
  configs.map(config => [config.type, config]),
)

export const getImportTypeConfig = (type: string): ImportTypeConfig =>
  importTypeConfigs[type] ?? { type }
